function isWebviewPath(asPath) {
    return isWebviewLayout(asPath) || hasWebviewQuery(asPath);
}

function isWebviewLayout(asPath) {
    return asPath.includes('/webview');
}

function hasWebviewQuery(asPath) {
    let querystring = asPath.split('#')[0];
    querystring = querystring.split('?')[1];
    const webviewQuery = new URLSearchParams(querystring).get('webview');
    return webviewQuery === 'yes' || webviewQuery === 'true';
}

function isEmbedPath(asPath) {
    return isEmbedLayout(asPath) || hasEmbedQuery(asPath);
}

function isEmbedLayout(asPath) {
    return asPath.includes('/embed');
}

function hasEmbedQuery(asPath) {
    let querystring = asPath.split('#')[0];
    querystring = querystring.split('?')[1];
    const embedQuery = new URLSearchParams(querystring).get('embed');
    return embedQuery === 'yes' || embedQuery === 'true';
}

function isWebviewPlayerPath(asPath) {
    return asPath.includes('/embed/appmobil/video') && hasWebviewQuery(asPath);
}

function isNoticiesPath(asPath) {
    const portal = asPath.split('/')[1];
    return portal === '3catinfo';
}

function isEsadirPath(asPath) {
    const portal = asPath.split('/')[1];
    return portal === 'esadir';
}

function is3catPath(asPath) {
    const portal = asPath.split('/')[1];
    return portal === '3cat';
}

function getLauncherCorporatiu(asPath) {
    const entorn = process.env.ENTORN;
    let launcher = 'https://assets.adobedtm.com/';
    let launch = 'ENc016da93aa6049f3892d0850889b18cd';

    if(asPath === '/corporatiu/rs/' || asPath === '/corporatiu/transparencia/' || asPath === '/premsa/') {
        launcher += 'f75b8874cf49/0dc24ed5325f/';
        launch = '240d28ea6550';
        switch (entorn) {
            case 'aws_dev':
            case 'aws_test':
                launch = '71bfaeac4973-development';
                break;
            case 'aws_pre':
                launch = 'c6eae888ecc0-staging';
                break;
        }
    }else{
        switch (entorn) {
            case 'aws_dev':
            case 'aws_test':
                launch = 'EN9abb4fc6f89b4fb7a0cb8c18a900b2d6-development';
                break;
            case 'aws_pre':
                launch = 'EN19ae4e3bea2c414aad044100dea46771-staging';
                break;
        }
    }

    return launcher + 'launch-' + launch + '.min.js';
}

function faviconCorporatiu(asPath) {
    const urlPath = asPath.split('/');
    const portal = urlPath[1];
    if (portal === 'tv3' || portal === 'catradio') {
        if (portal === 'catradio' && urlPath[2] === 'programacio') {
            if (urlPath[3] === 'catalunya-musica') {
                return 'catmusica';
            } else if (urlPath[3] === 'icat') {
                return 'icat';
            } else if (urlPath[3] === '3catinfo-radio') {
                return '3cat';
            } else {
                return portal;
            }
        }
        return portal;
    } else {
        return '3cat';
    }
}

export { isEmbedPath, isEsadirPath, isNoticiesPath, is3catPath, getLauncherCorporatiu, isWebviewPath, isWebviewPlayerPath, faviconCorporatiu };
